<template>
  <div class="home">
    <div
        class="effect-display-block"
        :style="{width:`${defaultWidth}px`,height:`${defaultHeight}px`}"
    >
      <div class="position-absolute">
        <Rain3D
            v-if="showEffect==='Rain3D' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
            :effect-theme="effectThemeComputed"
        />
        <WatchClock
            v-if="showEffect==='WatchClock' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Snow
            v-if="showEffect==='Snow' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Mandala
            v-if="showEffect==='Mandala' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Kaleidoscope
            v-if="showEffect==='Kaleidoscope' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <RainbowShoot
            v-if="showEffect==='RainbowShoot' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Swirl
            v-if="showEffect==='Swirl' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <TransformSpot
            v-if="showEffect==='TransformSpot' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <TimeTunnel
            v-if="showEffect==='TimeTunnel' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <TwistHole
            v-if="showEffect==='TwistHole' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Blossom
            v-if="showEffect==='Blossom' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Fireworks
            v-if="showEffect==='Fireworks' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <FlyInWording
            v-if="showEffect==='FlyInWording' && themeType ==='Effect'"
            :effect-theme="effectThemeComputed"
        />
        <MeteorShower
            v-if="showEffect==='MeteorShower' && themeType ==='Effect'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <SnowWording
            v-if="showEffect==='SnowWording' && themeType ==='Effect'"
            :effect-theme="effectThemeComputed"
        />
        <Snow3d
            v-if="showEffect==='Snow3d' && themeType ==='Effect'"
            :effect-theme="effectThemeComputed"
        />
        <Color
            v-if="showEffect==='Color' && themeType ==='Color'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <ImageMode
            v-if="showEffect==='Image' && themeType ==='Image'"
            :currentValue="currentTemperatureValue"
            :effect-theme="effectThemeComputed"
        />
        <Robot
            v-if="showEffect==='Robot' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
        />
        <PlanetCity
            v-if="showEffect==='PlanetCity' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
        />
        <Steampunk
            v-if="showEffect==='Steampunk' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
        />
        <Atmosphere
            v-if="showEffect==='Atmosphere' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
        />
        <Radio
            v-if="showEffect==='Radio' && themeType ==='Effect'"
            :sensorValue="sensorValueDetailComputed"
            :effect-theme="effectThemeComputed"
        />
      </div>

      <!-- 文字模式 -->
      <TextSliderSensor
          v-if="textData.Type === 'SliderSensor'"
          :textData="textDataComputed"
          :sensorValue="sensorValueDetailComputed"
          :effect-mode="effectMode"
      />
      <TextDuoSensor
          v-if="textData.Type === 'DuoSensor'"
          :textData="textDataComputed"
          :sensorValue="sensorValueDetailComputed"
          :effect-mode="effectMode"
      />
      <TextThreeSensor
          v-if="textData.Type === 'ThreeSensor'"
          :textData="textDataComputed"
          :sensorValue="sensorValueDetailComputed"
          :effect-mode="effectMode"
      />
      <TextFourSensor
          v-if="textData.Type === 'FourSensor'"
          :textData="textDataComputed"
          :sensorValue="sensorValueDetailComputed"
          :effect-mode="effectMode"
      />
      <TextTime
          v-if="textData.Type === 'Time'"
          :textData="textDataComputed"
          :effect-mode="effectMode"
      />
      <TextCustom
          v-if="textData.Type === 'Custom'"
          :textData="textDataComputed"
          :effect-mode="effectMode"
      />
      <!--  浮水印模式 -->
      <WatermarkMode
          v-show="watermarkDataComputed.HasImage"
          :watermarkData="watermarkDataComputed"
      />
    </div>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, computed, watchEffect} from "vue"
import defaultValue from "@/utils/defaultValue"
// AnimateMode
import Mandala from '@/components/AnimateMode/MandalaShowMode.vue'
import Blossom from '@/components/AnimateMode/BlossomShowMode.vue'
import TimeTunnel from "@/components/AnimateMode/TimeTunnelShowMode.vue"
import Snow from '@/components/AnimateMode/SnowShowMode.vue'
import TwistHole from "@/components/AnimateMode/TwistHoleShowMode.vue"
import ImageMode from "@/components/AnimateMode/ImgaeShowMode.vue"
import Color from "@/components/AnimateMode/ColorShowMode.vue"
import WatermarkMode from "@/components/AnimateMode/WatermarkShowMode.vue"
import Rain3D from "@/components/AnimateMode/Rain3DShowMode.vue";
import WatchClock from "@/components/AnimateMode/WatchClockShowMode.vue";
import FlyInWording from "@/components/AnimateMode/FlyInWordingShowMode.vue";
import Fireworks from "@/components/AnimateMode/FireworksShowMode.vue";
import MeteorShower from "@/components/AnimateMode/MeteorShowerShowMode.vue";
import Kaleidoscope from "@/components/AnimateMode/KaleidoscopeShowMode.vue";
import RainbowShoot from "@/components/AnimateMode/RainbowShootShowMode.vue";
import Swirl from "@/components/AnimateMode/SwirlShowMode.vue";
import TransformSpot from "@/components/AnimateMode/TransformSpotShowMode.vue";
import SnowWording from "@/components/AnimateMode/SnowWordingShowMode.vue";
import Snow3d from "@/components/AnimateMode/Snow3dShowMode.vue";
import Robot from "@/components/AnimateMode/RobotShowMode.vue";
import PlanetCity from "@/components/AnimateMode/PlanetCityShowMode.vue";
import Steampunk from "@/components/AnimateMode/SteampunkShowMode.vue";
import Atmosphere from "@/components/AnimateMode/AtmosphereShowMode.vue";
import Radio from "@/components/AnimateMode/RadioShowMode.vue";



import TextSliderSensor from "@/components/AnimateMode/TextSliderSensorShowMode.vue";
import TextTime from "@/components/AnimateMode/TextTimeShowMode.vue";
import TextDuoSensor from "@/components/AnimateMode/TextDuoSensorShowMode.vue";
import TextCustom from "@/components/AnimateMode/TextCustomShowMode.vue";
import TextThreeSensor from "@/components/AnimateMode/TextThreeSensorShowMode.vue";
import TextFourSensor from "@/components/AnimateMode/TextFourSensorShowMode.vue";


const {defaultWidth, defaultHeight} = defaultValue()

const defaultSensor = JSON.stringify(require('@/json/DefaultSensor.json'))
const showEffect = ref('') //要顯示哪個特效
const themeType = ref('') // 特效背景主題||純圖片影片背景主題||純色背景主題
const effectMode = ref('') // 特效Name
const textData = reactive({}) // 純文字背景主題資料
const textDataComputed = computed(() => {
  return textData
}) // 純文字背景主題資料
const watermarkData = reactive({}) // 浮水印資料
const watermarkDataComputed = computed(() => {
  return watermarkData
}) // 浮水印資料
const sensorValue = reactive({detail: {}}) // 取得sensor資料
const sensorValueDetailComputed = computed(() => {
  return sensorValue.detail
})
const configValue = reactive({}) // 取得config資料
const currentTemperatureValue = ref(null) // 參考sensor的Value

const effectTheme = reactive({}) // 特效主題的資料
const effectThemeComputed = computed(() => {
  return effectTheme
}) // 特效主題的資料

function processConfigByJsonFile (item){
  const {Screens} = item
  const {Text, Theme, Watermark} = Screens[0]
  return {
    Theme, // 主題模式 ()
    Text, // 文字模式
    Watermark // 浮水印
  }
}

function processThemeDetail (type, theme, texts){
  let RingColor = [0,0,0]
  if (texts) {
    const {Layout} = texts
    if (Layout ) RingColor = Layout[0].FontColors[1]
  }
  switch (type) {
    case 'Image':
      showEffect.value = 'Image'
      themeType.value = 'Image'
      effectMode.value = 'Image'
      return false
    case 'Color':
      showEffect.value = 'Color'
      themeType.value = 'Color'
      effectMode.value = 'Color'
      return false
    case 'Effect':
      showEffect.value = theme.Effect
      themeType.value = type
      // 取得 RingColor (Blossom use)
      if (showEffect.value === 'Blossom') Object.assign(effectTheme , theme, {RingColor})
      return false
    default:
      return false
  }
}

// processDynamicValueByJsonFile
// 取得硬體資訊(sensor), only dynamicMode
const processDynamicValueByJsonFile = (sensor,obj) =>{
  return obj[sensor].Value
}

const initTextData = () => {
  Object.assign(textData, {
    Type: "None"
  })
}

const initWatermark = () => {
  Object.assign(watermarkData, {
    HasImage: false,
    Image: "",
    Opacity: 100
  })
}

// 取得 sensor by browser
document.addEventListener('sensorChanged', (e) => {
  Object.assign(sensorValue.detail , e.detail)
  // sensorValue
  const {Sensor, IsDynamicMode, Type} = effectTheme
  if (Type === 'Effect' && IsDynamicMode) currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
});

// 取得 config by browser
document.addEventListener('configChanged', (e) => {
  if(!sensorValue.detail['CPULoad']) {
    const sensorDataParse = {detail: JSON.parse(defaultSensor)}
    Object.assign(sensorValue.detail , sensorDataParse.detail)
  }

  let screensData = e.detail
  // processConfig
  configValue.value = processConfigByJsonFile(screensData)
  const {
    Theme, // 主題模式 obj
    Text, // 文字模式
    Watermark // 浮水印
  } = configValue.value

  effectMode.value = Theme.Effect ? Theme.Effect : 'none'
  // 取得 主題模式 obj
  Object.assign(effectTheme , Theme)
  processThemeDetail(Theme.Type, Theme, Text)
  // 取得 文字模式
  initTextData()
  if (Text && Text !== undefined) Object.assign(textData , Text)
  // 取得浮水印
  initWatermark()
  if (Watermark && Watermark !== undefined) Object.assign(watermarkData , Watermark)
  // sensorValue
  const {Sensor, IsDynamicMode} = Theme
  if (themeType.value === 'Effect' && IsDynamicMode) currentTemperatureValue.value = processDynamicValueByJsonFile(Sensor, sensorValue.detail)
})

onMounted(() => {
  const sensorDataParse = {detail: JSON.parse(defaultSensor)}
  Object.assign(sensorValue.detail , sensorDataParse.detail)
})

watchEffect(() => {
  window.setSensorValue(`${JSON.stringify(sensorValue.detail)}`)
});
</script>
<style lang="scss">
@import "~@/assets/scss/HomeView.scss";
</style>
